import { render, staticRenderFns } from "./wrongTopic.vue?vue&type=template&id=415fe3cf&scoped=true"
import script from "./wrongTopic.vue?vue&type=script&lang=js"
export * from "./wrongTopic.vue?vue&type=script&lang=js"
import style0 from "../css/wrongTopic.scss?vue&type=style&index=0&id=415fe3cf&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "415fe3cf",
  null
  
)

export default component.exports